import { render, staticRenderFns } from "./BarTabConsumptionItemName.vue?vue&type=template&id=9398071a&scoped=true&"
import script from "./BarTabConsumptionItemName.vue?vue&type=script&lang=js&"
export * from "./BarTabConsumptionItemName.vue?vue&type=script&lang=js&"
import style0 from "./BarTabConsumptionItemName.vue?vue&type=style&index=0&id=9398071a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9398071a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9398071a')) {
      api.createRecord('9398071a', component.options)
    } else {
      api.reload('9398071a', component.options)
    }
    module.hot.accept("./BarTabConsumptionItemName.vue?vue&type=template&id=9398071a&scoped=true&", function () {
      api.rerender('9398071a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-bar/components/BarTabConsumptionItemName.vue"
export default component.exports